import { newsTranslationsSv } from './newsTranslations'

/** News page copy. */
export const pagesNewsSv = {
    title: 'Nyheter',
    loadingNews: 'Laddar nyheter...',
    ...newsTranslationsSv,
}
